import React from 'react';
import { FaArrowUp } from "react-icons/fa";
import './ClientTable.css';
import { CiFilter } from "react-icons/ci";
import { IoMdMore } from "react-icons/io";
import image from './image.png'
import { RiDeleteBin5Line } from "react-icons/ri";
const clients = [
  { id: 52514, name: 'Michael', email: 'michael87hl@gmail.com', status: 'Active', price: '$10,000', package: 'Monthly' },
  { id: 52514, name: 'Jacob', email: 'jacob.nute@gmail.com', status: 'Pending', price: '$10,000', package: 'Annual' },
  { id: 52514, name: 'Emily', email: 'emily08@gmail.com', status: 'New', price: '$20,000', package: 'Weekly' },
  { id: 52514, name: 'Brandon', email: 'brandon12@gmail.com', status: 'Pending', price: '$15,000', package: 'Annual' },
  { id: 52514, name: 'Anthony', email: 'anthony628@gmail.com', status: 'Active', price: '$17,000', package: 'Annual' },
];

const ClientTable = () => {
  return (
    <div className="table-container">
      <div className="table-header">
        <span>List of recent    <span className='h'>clients</span></span>
        <div className="table-filter">
          <input type="text" placeholder="Search by client ID or name..." />
          <button className="filter-btn">Filter</button>
        </div>
      </div>
      <table className="client-table">
        <thead>
          <tr>
            <th><input type="checkbox" /></th>
            <th>Client ID <FaArrowUp className='th'></FaArrowUp></th>
            <th>Name<FaArrowUp className='th'></FaArrowUp></th>
            <th>Status <img src={image} className='th'></img></th>
            <th>Price <img src={image} className='th'></img></th>
            <th>Package <img src={image} className='th'></img></th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {clients.map(client => (
            <tr key={client.email}>
              <td><input type="checkbox" /></td>
              <td className='q'>{client.id}</td>
              <td>
                <div className="client-info">
                  <img src={`https://i.pravatar.cc/150?u=${client.email}`} alt={client.name} className="avatar" />
                  <div className="client-details">
                    <span className="name">{client.name}</span>
                    <span className="email">{client.email}</span>
                  </div>
                </div>
              </td>
              <td><span className={`status ${client.status.toLowerCase()}`}>{client.status}</span></td>
              <td>{client.price}</td>
              <td>{client.package}</td>
              <td><button className="action-btn"> <RiDeleteBin5Line className='tha'></RiDeleteBin5Line><IoMdMore></IoMdMore></button></td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="pagination">
        <span>Showing 12 out of 180</span>
        <div className="pagination-controls">
          <button className="page-btn">Previous</button>
          <button className="page-btn active">1</button>
          <button className="page-btn">2</button>
          <button className="page-btn">3</button>
          <button className="page-btn">...</button>
          <button className="page-btn">10</button>
          <button className="page-btn">Next</button>
        </div>
      </div>
    </div>
  );
};

export default ClientTable;
